(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'Linkwise';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("linkwisefeed", TrackingModel);

        if (!Tracker || !Tracker.Properties.LinkWiseProgramId)
            return;

        var CanTrack = LhApp.Function.Tracking.canTrack()
            || TrackingModel.IsThankYouPage; // custom for linkwise

        var _isUserSelectedProduct;

        Init();

        function Init() {
            if (!CanTrack) return;

            //include linkwise tracking script
            (function (f, b, e, v, t) {
                if (f.lw) return;
                f.lw = f.lw || function () { { (f.lw.q = f.lw.q || []).push(arguments) } };
                f.lw.l = +new Date;
                t = b.createElement(e);
                t.async = !0;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s)
            })(window, document, 'script', '//go.linkwi.se/delivery/js/tl.js');
            lw('setProgram', Tracker.Properties.LinkWiseProgramId);
            lw('setDecimal', '.');

            /*TRACK home*/
            if (TrackingModel.IsHomePage) {
                lw('viewhome');
            }

            /*TRACK checkout start*/
            if (TrackingModel.IsCheckoutPage) {
                lw('checkout');
            }

            //TRACK product list 
            if (TrackingModel.IsProductListPage && TrackingModel.ProductListsData) {
                for (var list in TrackingModel.ProductListsData) {
                    var listItems = TrackingModel.ProductListsData[list];
                    for (var i = 0; i < listItems.length; i++) {
                        var product = listItems[i];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        lw("addItem", { id: productId, price: product.PriceWithoutVatN });
                    };
                }
                lw('listItems');
            }

            //TRACK product details
            if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                var product = TrackingModel.ProductData[0];
                var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                lw("addItem", { id: productId, price: product.PriceWithoutVatN });

                lw('viewItem');
            }

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                lw('setCurrency', LhApp.Context.Currency.Code);

                for (var i = 0; i < TrackingModel.CartProductsData.length; i++) {
                    var product = TrackingModel.CartProductsData[i];
                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                    lw("addItem", { id: productId, price: product.InitialPriceWithoutVatN, quantity: product.Quantity || 1, payout: 1 });
                }

                lw('setCoupon', TrackingModel.Order.DiscountAmountWithoutVatN);

                lw('thankyou', { orderid: TrackingModel.Order.Id, status: 'pending' });
            }
        }

        // IMPORTANT execute this scripts in all other pages except checkout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //TRACK add to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                var cartModel = envelope.message.data.Cart;

                //TRACK view cart
                if (TrackingModel.IsCartPage) {
                    for (var i=0; i < cartModel.Items.length; i++) {
                        var product = cartModel.Items[i];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        lw("addItem", { id: productId, price: product.Prices.PriceWithoutVatN, quantity: product.Quantity || 1, payout: 1 });
                    }

                    lw('viewCart');
                }
            });

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });
            //TRACK product view (changed)
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (!_isUserSelectedProduct)
                    return;

                var model = envelope.message.data.model;

                var product = model;
                var productId = LhApp.Function.Tracking.getFeedItemId(product, 'ProductChanged', Tracker);

                lw("addItem", { id: productId, price: product.Prices.UnitPriceWithoutVatN, quantity: product.Quantity || 1 });

                lw('viewItem');
            });
        }
    });
})();